import { render, staticRenderFns } from "./Mundos.vue?vue&type=template&id=2213a394&scoped=true"
import script from "./Mundos.vue?vue&type=script&lang=js"
export * from "./Mundos.vue?vue&type=script&lang=js"
import style0 from "./Mundos.vue?vue&type=style&index=0&id=2213a394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213a394",
  null
  
)

export default component.exports